const mutations = {
  changeTryVuex (state, value) {
    state.tryVuex = value
  },
  changeContracts (state, value) {
    state.contracts = value
  },
  addContracts(state, value) {
    state.contracts.push(value)
  },
  changeUnassignedProjects(state, value) {
    state.unassignedProjects = value
  },
  changePaginateUnassignedProjects(state, value) {
    state.paginateUnassignedProjects = value
  },
  changeAssignments(state, value) {
    state.assignments = value
  },
  changePaginateAssignments(state, value) {
    state.paginateAssignments = value
  },
  changeProjectId(state, value) {
    state.projectId = value
  },
  changeAssignmentId(state, value) {
    state.assignmentId = value
  },
  changeProject(state, value) {
    state.project = value
  },
  changeAssignment(state, value) {
    state.assignment = value
  },
  changeSelects(state, value) {
    state.selects = value
  },
  changeProjects(state,value) {
    state.projects = value
  },
  changeTaskValidations(state,value) {
    state.taskValidations = value
  },
  changeAssignmentTypes(state,value) {
    state.assignmentTypes = value
  },
  changeTaskValidation(state,value) {
    state.taskValidation = value
  },
  changeTypeEvents(state, value) {
    state.typeEvents = value
  },
  changeLaboralReference(state, value) {
    state.laboral_reference = value
  }
}
export default mutations;
